import styled from 'styled-components';
import { StyledCategoryItem } from './CategoriesList.style';
import { orderBy, random } from 'lodash';
import useInvestmentCarvingSetting from '../../settings/Configuration/useInvestmentCarvingSetting/useInvestmentCarvingSetting';
import { getColor } from 'common/constants/_colors';
import MultiLinesChart from 'components/MultiLinesChart';

const StyledLoadingCategories = styled.div``;
const StyledCategoryLoader = styled(StyledCategoryItem)`
  display: block;
  & > header {
    margin-bottom: 1rem;
  }
  & .MuiSkeleton-root {
    margin-bottom: 1rem;
    height: 1.5rem;
  }
`;

const getRandomLineSize = () => random(20, 80);

const CategoryLoader = ({ category }) => {
  const categoryLines = [
    {
      value: getRandomLineSize(),
      color: getColor('catskillGray'),
      loading: true
    },
    { value: category.benchmark, color: getColor('catskillWhite') }
  ];
  return (
    <StyledCategoryLoader>
      <header>{category.name}</header>
      <MultiLinesChart lines={categoryLines} />
    </StyledCategoryLoader>
  );
};

const LoadingCategories = () => {
  const investmentCarvingSetting = useInvestmentCarvingSetting();
  const { categories } = investmentCarvingSetting.value;
  const LoadingLines = orderBy(categories, 'order', 'desc').map(category => (
    <CategoryLoader key={category.name} category={category} />
  ));
  return <StyledLoadingCategories>{LoadingLines}</StyledLoadingCategories>;
};

export default LoadingCategories;
